var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.312 5.31a3 3 0 100 6 3 3 0 000-6zm-4.5 3a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.184 20.107a.63.63 0 00.688-.052c.2-.152.301-.41.259-.666l-.33-2.007a.625.625 0 01.171-.54l1.393-1.417a.702.702 0 00.165-.697.66.66 0 00-.526-.464l-1.904-.288a.625.625 0 01-.471-.351l-.857-1.81a.65.65 0 00-.585-.38.65.65 0 00-.585.38l-.856 1.81a.625.625 0 01-.471.35l-1.904.29a.649.649 0 00-.437.277.701.701 0 00.075.884l1.394 1.417a.623.623 0 01.17.539l-.33 2.007a.695.695 0 00.26.666.634.634 0 00.687.052l1.697-.93a.625.625 0 01.6 0l1.698.93zM3.935 19.44c0-1.141 1.353-3.4 4.313-3.4h4.49c-.405-.411-.676-.902-.49-1.498l-4-.002c-3.786 0-5.813 2.929-5.813 4.9a.75.75 0 001.5 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/Membership.4848bc469eea0197c3d3c353ba074ae0.svg";
export { ForwardRef as ReactComponent };